import * as Scrivito from "scrivito";
import getLanguage from "../../../../utils/getLanguage";

function SubmitButton(props) {
  const lang = getLanguage(Scrivito.currentPage());
  return (
    <Scrivito.LinkTag
      className="btn btn-primary ml-auto"
      onClick={props.submitAnswers}
    >
      <span className="form-page-buttons-next">
        {lang === "de" ? "Absenden" : "Submit"}
      </span>
      <i className="las la-angle-right" />
    </Scrivito.LinkTag>
  );
}

export default SubmitButton;
